'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import ComplianceNavigator from './ComplianceNavigator';
import RegulationMatrix from './RegulationMatrix';
import NetZeroRoadmap from './NetZeroRoadmap';
import AIGapAnalysis from './AIGapAnalysis';
import ConsultationSection from './ConsultationSection';
import DPDPPrivacyDisclosure from './DPDPPrivacyDisclosure';
import CookieConsentBanner from './CookieConsentBanner';
import SSLSecurityIndicator from './SSLSecurityIndicator';
import Footer from '@/app/homepage/components/Footer';
import LanguageSelector from '@/app/homepage/components/LanguageSelector';
import WhatsAppButton from '@/app/homepage/components/WhatsAppButton';
import { trackUserLogin, collectUserMetadata } from '@/lib/userTracking';

const BRSRESGInteractive = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [selectedRegulation, setSelectedRegulation] = useState<string | null>(null);
  const [selectedIndustry, setSelectedIndustry] = useState<string | null>(null);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('gencarbon_language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }

    // Track user session on page load
    const initializeTracking = async () => {
      try {
        const metadata = collectUserMetadata();
        console.log('Page Visit Tracked:', metadata);
        
        // Track as anonymous session initially
        await trackUserLogin(undefined, 'anonymous_visit');
      } catch (error) {
        console.error('Tracking initialization failed:', error);
      }
    };

    initializeTracking();
  }, []);

  const handleLanguageChange = (language: string) => {
    setCurrentLanguage(language);
    localStorage.setItem('gencarbon_language', language);
  };

  return (
    <>
      {/* SSL Security Indicator - Fixed Position */}
      <SSLSecurityIndicator currentLanguage={currentLanguage} />

      {/* Language Selector - Fixed Position */}
      <div className="fixed top-20 right-4 z-40">
        <LanguageSelector
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Main Content */}
      <HeroSection currentLanguage={currentLanguage} />
      
      {/* DPDP Privacy Disclosure Section */}
      <DPDPPrivacyDisclosure currentLanguage={currentLanguage} />
      
      <ComplianceNavigator
        currentLanguage={currentLanguage}
        onSelectRegulation={setSelectedRegulation}
        onSelectIndustry={setSelectedIndustry}
      />
      <RegulationMatrix
        currentLanguage={currentLanguage}
        selectedRegulation={selectedRegulation}
        selectedIndustry={selectedIndustry}
      />
      <NetZeroRoadmap currentLanguage={currentLanguage} />
      <AIGapAnalysis currentLanguage={currentLanguage} />
      <ConsultationSection currentLanguage={currentLanguage} />
      <Footer currentLanguage={currentLanguage} />

      {/* WhatsApp Floating Button */}
      <WhatsAppButton currentLanguage={currentLanguage} />

      {/* Cookie Consent Banner - Fixed Bottom */}
      <CookieConsentBanner currentLanguage={currentLanguage} />
    </>
  );
};

export default BRSRESGInteractive;